import { cn } from "@/utils/theme";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  ScrollArea,
} from "@elaniintc/goes-design-system";
import { useState } from "react";
import { DataCenterConditionOperations } from "./condition-operations";
import type { DCOperation } from "../types";

export interface ScopeConditionSelector {
  selected: DCOperation | null;
  scopeType: "dateScope" | "userScope";
  onSelectCondition: (condition: DCOperation) => void;
  group?:
    | "middle"
    | "up-left"
    | "up-right"
    | "left"
    | "right"
    | "down"
    | "middle-left"
    | "middle-right"
    | "down-left"
    | "down-right"
    | "up"
    | "single";
}

export const DCScopeConditionSelector = ({
  selected,
  scopeType,
  onSelectCondition,
  group = "left",
}: ScopeConditionSelector) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="quiet"
          group={group}
          className="h-full text-body-loud min-w-0 max-w-1/2"
        >
          <p className="truncate">{selected?.label ?? "Condición"}</p>
          <Icon
            type="far"
            name="angle-down"
            className={cn(
              "transition-transform duration-200",
              isOpen ? "rotate-180" : "",
            )}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="end"
        className="border-neutral h-full rounded-lg w-[238px]"
      >
        <ScrollArea className="max-h-[264px]">
          {DataCenterConditionOperations[scopeType].map((condition) => (
            <DropdownMenuItem
              key={condition.name}
              className="text-body h-11 text-base"
              onClick={() => {
                onSelectCondition?.(condition);
                setIsOpen(false);
              }}
            >
              {condition.label}
            </DropdownMenuItem>
          ))}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
